<template>
  <el-form
    ref="inforForm"
    :model="inforForm"
    :rules="baseRule"
    label-width="auto"
    class="inforForm"
    size="mini"
  > 
    <el-form-item v-for="(item,index) in inforFormItem.variablList" :key="index" class="nameContract" :label="item.name+'：'" :prop="item.sourceProprety">
        <el-input v-if="item.valueDisplayType==1" v-model="inforForm[item.sourceProprety]" :placeholder="item.title" @blur="storeData"></el-input>
        <el-select v-if="item.valueDisplayType==2" v-model="inforForm[item.sourceProprety]" :placeholder="item.title" @change="storeData">
            <el-option :label="items.value" :value="items.id+''" v-for="(items,indexs) in item.paramsList" :key="indexs"></el-option>
        </el-select>
        <template v-if="item.valueDisplayType==3">
          <el-checkbox-group v-model="inforForm[item.sourceProprety]" @change="storeData">
            <el-checkbox v-for="(i,ind) in item.paramsList" :key="ind" :label="item.value"></el-checkbox>
          </el-checkbox-group>
        </template>
        <template v-if="item.valueDisplayType==4">
            <el-date-picker
              type="date"
              :placeholder="item.title"
              v-model="inforForm[item.sourceProprety]"
              @change="storeData"
              :clearable="false"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
        </template>
        <template v-if="item.valueDisplayType==5">
         <el-select v-model="inforForm[item.sourceProprety]" :placeholder="item.title" @change="storeData">
            <el-option :label="items" :value="items" v-for="(items,indexs) in 31" :key="indexs"></el-option>
        </el-select>
        </template>
        <span class="formItemDscp" v-if="item.valuesExample">示例：{{item.valuesExample}}</span>
    </el-form-item>   
    <div class="clear-all-form" @click="clearAllData">
      清除数据
    </div>
  </el-form>
</template>
<script>
import CustomerDatePicker from "@common/date-picker";
import BaseApi from "@lib/baseApi.js";
var validateLoanAmount = (rule, value, callback) => {
  if(!value){
      return callback(new Error('借款金额不能为空'));
  }else{
      if(value>50000000){
          return callback(new Error('最高限制5000万,请重新填写'));
      }else if(value<1){
          return callback(new Error('输入不低于1元整数'));
      }
  }
}
export default {
  props:{
    fqTemplateList:{
      type:Array,
      default:[]
    },
    fileVariableInfo:{
      type:Array,
      default:[]
    }
  },
  data() {
    return {
      //表单数据
      inforForm: {},
      //表单验证
      baseRule:{},
      inforFormItem:[],
      showInput:false
    };
  },
  components: { CustomerDatePicker },
  computed: {
    getSinDataForEndDate() {
      let endDateTimeTmp = this.inforForm.loanStartDate;
      return this.handlerOption(endDateTimeTmp);
    }
  },
  created() {
    this.setInfoData();
  },
  methods: {
    /**
     * 设置表单初始key,value
     * 
     * valueDisplayType-展示类型：1-输入框；2-下拉框；3-复选框，4-日期选择框，5-固定值天数选择。用于前端展示
     * **/
    setInfoData(){
      this.$bus.on('curFqTemplate',(value)=>{
        this.inforFormItem=value;
        this.setInfoDatas();
      });
    },
    setInfoDatas(){
      let inforFormItemData=sessionStorage.getItem('inforFormItem'+this.inforFormItem.templateId);
      if(this.fileVariableInfo.length){
        let fileVariableInfoParams=this.fileVariableInfo.filter(item=>item.templateId == this.inforFormItem.templateId)[0];
         this.inforFormItem.variablList.forEach((item,index)=>{
          //设置初始值
          if(!inforFormItemData && JSON.parse(Object.values(fileVariableInfoParams.params).length==0)){
            this.$set(this.inforForm,item.sourceProprety,item.valueDisplayType==3?[]:'');
          }else if(inforFormItemData){
            this.$set(this.inforForm,item.sourceProprety,JSON.parse(inforFormItemData)[item.sourceProprety]);
          }else if(JSON.parse(Object.values(fileVariableInfoParams.params).length>0)){
            this.$set(this.inforForm,item.sourceProprety,JSON.parse(fileVariableInfoParams.params)[item.sourceProprety][0]);
          }
          //正则校验
          let regFun=(rule, value, callback) => {
              if (value == '') {
                callback(new Error(item.title));
              } else if(item.valueCheckConstraint !=undefined){
                let reg=new RegExp(item.valueCheckConstraint);
                if(!reg.test(value)){
                   callback(new Error('输入格式错误'));
                }
                callback();
              }
              callback();
            };
          //设置校验条件
          this.$set(this.baseRule,item.sourceProprety,[{required: true, validator: regFun, trigger: item.valueDisplayType==2 || item.valueDisplayType==4 ?'change':'blur'}])
        })
      }else{
        this.inforFormItem.variablList.forEach((item,index)=>{
          //设置初始值
          if(!inforFormItemData){
            this.$set(this.inforForm,item.sourceProprety,item.valueDisplayType==3?[]:'');
          }else if(inforFormItemData){
            this.$set(this.inforForm,item.sourceProprety,JSON.parse(inforFormItemData)[item.sourceProprety]);
          }
          //正则校验
          let regFun=(rule, value, callback) => {
              if (value == '') {
                callback(new Error(item.title));
              } else if(item.valueCheckConstraint !=undefined){
                let reg=new RegExp(item.valueCheckConstraint);
                if(!reg.test(value)){
                   callback(new Error('输入格式错误'));
                }
                callback();
              }
              callback();
            };
          //设置校验条件
          this.$set(this.baseRule,item.sourceProprety,[{required: true, validator: regFun, trigger: item.valueDisplayType==2 || item.valueDisplayType==4 ?'change':'blur'}])
        })
      }
        
        
    },
    async save() {
      try {
        await this.$refs.inforForm.validate();
        //处理携带%号参数
        let dailyInterestRate="",annualInterestRate="",newData={};
        if(this.inforForm.hasOwnProperty('dailyInterestRate')){//日利率
          if(this.inforForm.dailyInterestRate.indexOf('%')!= -1){
            dailyInterestRate=this.inforForm.dailyInterestRate.replace(/\%/g,"%25")
          }else{
            dailyInterestRate=this.inforForm.dailyInterestRate
          }
        }
        if(this.inforForm.hasOwnProperty('annualInterestRate')){//年利率
          if(this.inforForm.annualInterestRate.indexOf('%')!= -1){
            annualInterestRate=this.inforForm.annualInterestRate.replace(/\%/g,"%25")
          }else{
            annualInterestRate=this.inforForm.annualInterestRate
          }
        }
        console.log(this.inforForm, 'this.inforForm')
        newData={...this.inforForm,dailyInterestRate,annualInterestRate};
        console.log(newData, 'newData')
        return Promise.resolve({
          valid: true,
          data: newData
        });
      } catch (e) {
        return Promise.resolve({
          valid: false,
          data: null
        });
      }
    },
    //缓存填入的数据
     storeData(){
       sessionStorage.setItem('inforFormItem'+this.inforFormItem.templateId,JSON.stringify(this.inforForm));
     },
    isHaveStartData() {
      if (!this.inforForm.loanStartDate) {
        this.$message.warning("请先选择借款起始日期");
      }
    },
    handlerOption(endDateTimeTmp, flag) {
      let endDateTime = "";
      if (endDateTimeTmp ) {
        endDateTime = new Date(
          endDateTimeTmp.slice(0, 4),
          endDateTimeTmp.slice(5, 7) - 1,
          endDateTimeTmp.slice(8, 10)
        ).getTime();
      }
      return {
        disabledDate(time) {
          if (endDateTime) {
            if (flag == "dealLine") {
              return (
                time.getTime() > endDateTime ||
                time.getTime() < Date.now() - 1000 * 60 * 60 * 24
              );
            } else {
              return time.getTime() < endDateTime;
            }
          } else {
            return time.getTime() < Date.now() - 1000 * 60 * 60 * 24;
          }
        }
      };
    },
    // checkloanPeriods(){
    //     if(this.inforForm.loanPeriods=='6'){
    //         this.showInput=true;
    //     }else{
    //         this.showInput=false;
    //     }
    // },
    //清空数据
    clearAllData(){
      this.$refs.inforForm.resetFields();
      this.$refs.inforForm.clearValidate();
      sessionStorage.removeItem('inforFormItem'+this.inforFormItem.templateId);
    },
  },
  mounted() {},
  destroyed(){
    sessionStorage.removeItem('inforFormItem'+this.inforFormItem.templateId);
  },
  watch:{
    'fileVariableInfo'(data){
      this.setInfoDatas();
    }
  }
};
</script>
<style lang="scss">
.inforForm {
  position: relative;
  .el-input__inner:focus {
    border-color: #D81212;
    outline: 0;
  }
  .el-range-editor.is-active,.el-select .el-input.is-focus .el-input__inner {
    border-color: #D81212;
  }
  .el-input__prefix{
      left: 320px;
      border-left: 1px solid #E4E8EB;
      padding-left: 2px;
  }
  .el-input--prefix .el-input__inner{
      padding:0px 15px;
  }
 
  .nameContract {
    .el-input__inner {
      width: 350px;
    }
  }
  .input-right{
    position: absolute;
    top: 0px;
    left: 320px;
    height: 100%;
    border-left: 1px solid #E4E8EB;
    text-align: center;
    width: 26px;
    font-size: 12px;
    color: #5A5A5A;
  }
  .datePickerStyle {
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      //width: 160px;
    }
    .chooseWay {
      .validityBox {
        color: #969696;
        .el-input {
          width: 40px;
          margin: 0 10px;
          .el-input__inner {
            border: 0;
            border-radius: 0;
            padding: 0 10px;
            border-bottom: 1px solid #E4E8EB;
          }
        }
        span {
          font-size: 14px;
          font-weight: 400;
          color: #2b2b2b;
        }
        .timeTypeBox {
          display: inline-block;
          position: relative;
          .el-select {
            .el-input {
              width: 40px;
              text-align: center;
              margin: 0;
              .el-input__inner {
                padding: 0;
                border: 0;
              }
            }
          }
        }
      }
    }
  }

  .formItemDscp {
    font-size: 12px;
    color: #969696;
    margin-left: 20px;
  }
  .el-form-item__label {
    font-size: 14px !important;
    font-weight: 400;
    color: #2b2b2b !important;
  }
  .clear-all-form{
    // position: absolute;
    // top: -57px;
    // left: 342px;
    width: 74px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    font-size: 14px;
    border-radius: 5px;
    color: #646464;
    border: 1px solid #c8c8c8;
    cursor: pointer;
    margin-left: 110px;
  }
  .clear-all-form:hover{
    border-color: #D81212;
    background: #D81212;
    color: #fff;
  }
}

.nameContract {
  .el-input {
    width: auto;
  }
}
</style>